import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
import { isEmpty } from '@ember/utils';
import { computed } from '@ember/object';
import { attr } from '@ember-data/model';
export default EmberDataBaseFragment.extend({
  token: attr('string'),
  name: attr('string'),
  emailAddress: attr('string'),
  phoneNumber: attr('string'),
  ordinal: attr('number'),
  removed: attr('boolean'),
  isRemoved: computed('emailAddress', 'name', 'phoneNumber', function () {
    return isEmpty(this.name) && isEmpty(this.emailAddress) && isEmpty(this.phoneNumber);
  })
}).reopenClass({
  _modelNameForMigration: 'squareup/inventory/v3/vendor-contact'
});